import * as React from 'react';

export const LazyElevatedRiskLessThanOneYearExclusion = React.lazy(() => import('./component'));
